import React from "react";
import heroImg from "@/app/blog/(posts)/achievements_2025/hero.png";
import type { ArticleMetadata } from "@/components/articles/ArticleMetadata.js";


export const blogAchievements2025: ArticleMetadata = {
    id: "blogAchievements2025",
    shortTitle: "Get the new Achievements!",
    fullTitle: "Get the new achievements!",
    description: "We have released the first set of 10 achievements",
    htmlDescription: <>
        We have released the first set of 10 achievements,
        and you can earn them right now!
    </>,
    path: "/blog/achievements_2025",
    date: "31st October, 2025",
    datetime: "20251031T090000Z",
    authors: [{
        name: "Padraig Lamont",
        url: "https://padraiglamont.com",
    }],
    image: {
        src: heroImg,
        alt: "My favourite new achievement, beating the Panda Bot",
    },
    dir: [
        { label: "Home", href: "/" },
        { label: "Blog", href: "/blog" },
    ],
};
